function RouteParcelsGridHeaders() {
    return (
        <div className="col-span-12 grid grid-cols-7        sm:grid-cols-10                         lg:grid-cols-10">
            <div className="col-span-2                                                              lg:col-span-1">Scanned Route</div>
            <div className="col-span-2 order-5                                                      lg:col-span-1 lg:order-2">Assigned Route</div>
            <div className="col-span-2                                                              lg:col-span-1 lg:order-3">Control #</div>
            <div className="col-span-3 order-3              sm:col-span-4                           lg:col-span-3">Tracking #</div>
            <div className="col-span-0 order-last invisible sm:col-span-2 sm:visible sm:order-5     lg:col-span-1 lg:order-6">Service</div>
            <div className="col-span-2 order-7              sm:col-span-4 sm:order-6                lg:col-span-1 lg:order-7">Zip</div>
            <div className="col-span-2 order-6              sm:order-4                              lg:col-span-1 lg:order-5">Del. Date</div>
            <div className="col-span-1 order-8              sm:col-span-2                           lg:col-span-1">Reroute</div>
         </div>
    )
}

export default RouteParcelsGridHeaders;